<template>
  <v-container>
    <h1>Konfigurasjon av leveringsmetoder</h1>
    <AdminBreadcrumbs tail-text="Leveringsmetoder" />

    <AdminDeliveryMethodForm
      v-for="delivery_method in delivery_methods"
      :key="delivery_method.id"
      :delivery-method="delivery_method"
      :vat-classes="vat_classes"
      @update:delivery-methods="updateDeliveryMethods()"
    />

    <AdminDeliveryMethodForm
      :vat-classes="vat_classes"
      @update:delivery-methods="updateDeliveryMethods()"
    />
  </v-container>
</template>

<script>
import AdminDeliveryMethodForm from "@/components/AdminDeliveryMethodForm.vue";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs.vue";
import backend from "@/backend";

export default {
  name: "AdminDeliveryMethods",

  components: {
    AdminDeliveryMethodForm,
    AdminBreadcrumbs,
  },

  data: function () {
    return {
      delivery_methods: [],
      vat_classes: [],
    };
  },

  computed: {
    organizationId() {
      return this.$store.state.auth.organization.id;
    },
  },

  async created() {
    this.delivery_methods = await backend.get("deliverymethods/", {
      organization: this.organizationId,
    });
    this.vat_classes = await backend.get("vat/");
  },

  methods: {
    async updateDeliveryMethods() {
      this.delivery_methods = await backend.get("deliverymethods/", {
        organization: this.organizationId,
      });
    },
  },
};
</script>
